module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/11bf76b0779a57b30e614213f43eb983.png";